import React from "react";

import { Badge } from "../../../common/components/core";
import { PaymentStatus } from "../../../types/payment";
import { UserRole } from "../../../types/userCurrent";
import { hasPaymentAction } from "../../../utils/payment";

type PaymentStatusBadgeProps = {
    paymentStatus: PaymentStatus;
    roles?: UserRole[];
    showActionRequired?: boolean;
    isPaymentReceipt?: boolean;
};

const PaymentStatusBadge = ({
    paymentStatus,
    roles,
    showActionRequired,
    isPaymentReceipt = false,
}: PaymentStatusBadgeProps): JSX.Element => {
    if (roles && showActionRequired && hasPaymentAction(roles, paymentStatus)) {
        return !isPaymentReceipt ? (
            <Badge type="success">Payment Submitted</Badge>
        ) : (
            <Badge type="danger">Action Required</Badge>
        );
    }

    if (!isPaymentReceipt) {
        return <Badge type="success">Payment Submitted</Badge>;
    }

    switch (paymentStatus) {
        case PaymentStatus.PENDING:
        case PaymentStatus.SUBMITTED:
            return <Badge type="success">Payment Submitted</Badge>;
        case PaymentStatus.COMPLETED:
            return <Badge type="success">Payment Completed</Badge>;
        case PaymentStatus.FAILED:
            return <Badge type="danger">Payment Failed</Badge>;
    }
};

export default PaymentStatusBadge;
